import type {IModule} from '../../core/interfaces/module.ts';
import {globalEventManager} from '../../core/events/event-manager.ts';
import {prescript} from '../../core/providers/prescript.ts';
import {broadcastCookieUpdateToIframes} from './events/utils/iframe-broadcast.ts';
import {contentHeightEventHandler} from './events/content-height.event.ts';
import {iframeContextReadyEventHandler} from './events/iframe-context-ready.event.ts';
import {closeFullscreenModalEventHandler, toggleDrawerEventHandler} from './events/toggle-drawer.event.ts';
import {getRecommendedSizeEventHandler} from './events/get-recommended-size.event.ts';
import type {BodyMeasurements} from '../similar/types/body-measurements.ts';
import {clickProductEventHandler} from './events/click-product.event.ts';

class CommonEvents implements IModule {
    private removeScopedBridge?: () => void;

    async init() {
        this.handleEvents();

        window.addEventListener('beforeunload', () => {
            this.removeScopedBridge?.();
        });
    }

    private handleEvents() {
        const trustedOrigins = [new URL(prescript.baseFashionHintUrl).origin];
        globalEventManager.subscribePostMessages(trustedOrigins);

        this.removeScopedBridge = globalEventManager.subscribeCustomEvents(['vfr:sync-recommendation']);

        globalEventManager.subscribe<unknown>('vfr:sync-recommendation', () => {
            broadcastCookieUpdateToIframes();
        });

        globalEventManager.subscribe<{ height?: number; context?: 'similar' }>(
            'postmessage:szb_content_height',
            (payload) => contentHeightEventHandler(payload)
        );

        globalEventManager.subscribe<unknown>(
            'postmessage:szb_iframe_context_ready',
            () => iframeContextReadyEventHandler()
        );

        globalEventManager.subscribe<{ context?: string }>(
            'postmessage:szb_toggle_drawer',
            (payload) => {
                if (payload?.context !== 'similar' && payload?.context !== 'drawer') return;
                toggleDrawerEventHandler();
            }
        );

        globalEventManager.subscribe<{ context?: string }>(
            'postmessage:szb_close_fullscreen_modal',
            (payload) => {
                if (payload?.context !== 'similar') return;
                closeFullscreenModalEventHandler();
            }
        );

        globalEventManager.subscribe<{ data?: BodyMeasurements }>(
            'postmessage:szb_get_recommended_size',
            async (payload) => {
                await getRecommendedSizeEventHandler(payload);
            }
        );

        globalEventManager.subscribe<{ productLink?: string; type?: 'similar' }>(
            'postmessage:szb_click_product',
            (payload) => clickProductEventHandler(payload)
        );
    }
}

export default new CommonEvents();